export const APPLICATION_SETTINGS_CODES = {
  D002: 'imageCompressionValueInvalid',
};
